import { Storage } from "aws-amplify";

Storage.configure({
  customPrefix: { public: "" }
});

const getFile = async (fileName) => {
  const result = await Storage.get(fileName, {
    download: true,
    rel: "preconnect",
    cacheControl: "no-cache"
  });

  return await result.Body.text();
};

const awsStorageService = {
  getFile
};

export default awsStorageService;
